import businessType from './business-type'
import businessCategory from './business-category'
import partner from './partner'
import evaluation from './evaluation'

export default [
  ...partner, ...businessType, ...businessCategory, ...evaluation,
]
